import React from 'react';
import PropTypes from 'prop-types';

import {ButtonContainer, Text} from './button_group.styled';
export const Button = ({children, value, left, right, isSelected, onClick, 'data-cy': dataCy}) => {
	const handleClick = () => {
		onClick(value);
	};
	return (
		<ButtonContainer onClick={handleClick} isSelected={isSelected} data-cy={dataCy}>
			<Text left={left} right={right}>
				{children}
			</Text>
		</ButtonContainer>
	);
};

Button.propTypes = {
	/**
	 * Text to show on the button, should only contain a single string
	 */
	children: PropTypes.string.isRequired,
	/**
	 * Indicates whether a button is selected
	 * Internal logic only supports one selected button atm.
	 */
	isSelected: PropTypes.bool,
	/**
	 * an optional value which is return on select
	 * if not supplied, the children text will be returned on select
	 */
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	/**
	 * DO NOT SET - internal prop used by ButtonGroup
	 */
	onClick: PropTypes.func,
	/**
	 * DO NOT SET - internal prop used by ButtonGroup
	 * sets if left border should be displyed
	 */
	left: PropTypes.bool,
	/**
	 * DO NOT SET - internal prop used by ButtonGroup
	 * sets if left border should be displyed
	 */
	right: PropTypes.bool,
};
